import { CardHeader as Header, CardHeaderProps as HeaderProps, makeStyles, Typography } from '@material-ui/core'
import MetatagsIcon from '@material-ui/icons/FindInPage'
import InfoIcon from '@material-ui/icons/Info'
import TagIcon from '@material-ui/icons/LocalOffer'
import ShareIcon from '@material-ui/icons/Share'
import TranslationsIcon from '@material-ui/icons/Translate'
import BlocksIcon from '@material-ui/icons/ViewAgenda'
import clsx from 'clsx'
import React from 'react'
import { Spinner } from 'components'
import { Color } from 'theme/style'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      display: 'flex',
      flexDirection: 'column'
    },
    '& > div:first-of-type': {
      display: 'none'
    },
    '& > div:nth-child(2)': {
      flex: 1
    }
  },
  titleContainer: {
    display: 'none',
    flex: '0 0 auto',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      width: '100%',
      padding: theme.spacing(0, 1)
    }
  },
  titleIcon: {
    display: 'none',
    color: Color.Primary,
    width: '1.8rem',
    height: '1.8rem',
    marginRight: theme.spacing(0.5),
    position: 'relative',
    top: '2px'
  },
  icon: {
    width: '1.3rem',
    height: '1.3rem',
  },
  actions: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '40px',
    minHeight: '40px',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flex: '0 0 100%',
    },
    '& >div': {
      marginBottom: '0 !important',
      '& >div': {
        marginBottom: '0 !important'
      }
    }
  }
}))

type IconsType = 'default' | 'blocks' | 'info' | 'metatags' | 'tags' | 'translations' | 'share' | 'global'
const icons: { [key: string]: React.ComponentType } = {
  default: React.Fragment,
  blocks: BlocksIcon,
  info: InfoIcon,
  metatags: MetatagsIcon,
  tags: TagIcon,
  translations: TranslationsIcon,
  share: ShareIcon,
  global: ShareIcon
}

interface CardHeaderProps extends HeaderProps {
  title: string
  iconName?: IconsType
  enableLoadingSpinner?: boolean
  isLoading?: boolean
}
const CardHeader = ({ ...props }: CardHeaderProps) => {
  const classes = useStyles()
  const Icon = icons[props.iconName || 'default'];

  const enableLoadingSpinnerValue = props.enableLoadingSpinner ?? false

  function renderActions(): React.ReactNode | null {
    if (enableLoadingSpinnerValue == null) return props.action
    if (enableLoadingSpinnerValue === false) return props.action
    if (enableLoadingSpinnerValue === true && props.isLoading === true) return <Spinner type="small" />
    return null
  }

  return (
    <Header {...props} className={clsx(classes.root, props.className)}
      title={<>
        <div className={classes.titleContainer}>
          {props.iconName != null && <div className={classes.titleIcon}><Icon></Icon></div>}
          <Typography color="textPrimary" variant="h2">{props.title}</Typography>
        </div>
      </>
      }
      action={
        props.action != null &&
        <div className={classes.actions}>
          {renderActions()}
        </div >
      }
    />
  )
}

export default CardHeader
